import { render, staticRenderFns } from "./OwnerValidationConfirmation.vue?vue&type=template&id=422a42c6&"
import script from "./OwnerValidationConfirmation.vue?vue&type=script&lang=js&"
export * from "./OwnerValidationConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./OwnerValidationConfirmation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports